import { createAction } from 'redux-actions'

const ns = 'challenge-admin/'

export const createGoal = createAction(`${ns}CREATE_GOAL`)
export const createGoalSuccess = createAction(`${ns}CREATE_GOAL_SUCCESS`)
export const createGoalFail = createAction(`${ns}CREATE_GOAL_FAIL`)

export const updateGoal = createAction(`${ns}UPDATE_GOAL`)
export const updateGoalSuccess = createAction(`${ns}UPDATE_GOAL_SUCCESS`)
export const updateGoalFail = createAction(`${ns}UPDATE_GOAL_FAIL`)

export const deleteGoal = createAction(`${ns}DELETE_GOAL`)

// Reset submit state on screen enter/reload.
export const resetSubmitInProgress = createAction(`${ns}RESET_SUBMIT_IN_PROGRESS`)
